// SCREEN_ADMIN (属性承認) で使うAPI

export const getPendingAttributes = async (page = 1) => {
  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/admin/pending?page=${page}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  const data = await response.json();

  return [data.items, data.total];
};

export const approveAttribute = async (vtuberId, attribute) => {
  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/admin/attributes/${vtuberId}/approve`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ 
        attribute:attribute,
      }),
    },
  );

  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new Error(data?.error ?? "属性の承認に失敗しました");
  }
};
